<template>
  <div
    tabindex="0"
    ref="contextTitle"
    id="contextTitle"
    class="list-item"
    @mouseover="!dragging && !animating ? (hovering = true) : null"
    @mouseout="hovering = false"
    @keydown.down.exact=""
    @keydown.enter.exact.self.prevent=""
    @keydown.up.exact.stop
  >
    <v-layout>
      <v-flex
        xs12
        :class="{
          'question-list-item': true,
          editing: !!editing,
          outline: selected && !editing,
          'pl-1': true,
          'lighten-2': selected && !editing,
          'lighten-4': hovering,
          'lighten-5': editing
        }"
      >
        <v-layout>
          <v-flex>
            <div
              v-if="!userCanEdit"
              v-html="contextTitle.html"
              :style="`font-size: 22px; font-weight: 300; padding-left: 20px;`"
              :class="{
                'context-title': true,
                'py-1': true,
                'grey--text': true,
                'text--darken-1': selected || (!hovering && !editing)
              }"
            ></div>
            <content-editor
              v-else
              :id="`editor-contextTitle`"
              ref="editor"
              :class="{
                'context-title': true,
                'py-1': true,
                'grey--text': true,
                'text--darken-1': selected || (!hovering && !editing)
              }"
              :style="`font-size: 22px; font-weight: 300; padding-left: 20px;`"
              v-model="contextTitle"
              :placeholder="'Context topic'"
              :preventDefaultCtrl="true"
              :disabled="false"
              :emitText="true"
              :preventTab="true"
              @keyCtrlEnter="createNewItem"
              @keyEnter="editing = false"
              @keyEsc="editing = false"
              @keydown.up.stop
              @keydown.down.stop
            >
            </content-editor>
          </v-flex>
          <!-- <v-btn :disabled="editing" icon small class="mb-0 mx-0 mt-1" @click.stop="enableEditing">
            <v-icon v-show="!editing && hovering" icon small>edit</v-icon>
          </v-btn> -->
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ContentEditor from '@/components/ContentEditor';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      hovering: false
    };
  },
  components: { ContentEditor },
  computed: {
    ...mapGetters('context', ['context', 'questions', 'userCanEdit']),
    ...mapState('views/context', [
      'dragging',
      'animating',
      'hoveringItem',
      'editingQuestionId',
      'selectedPageId',
      'focusTo'
    ]),
    editing: {
      get() {
        //  returns true if item is being edited
        return this.editingQuestionId == this.context.id;
      },
      set(v) {
        //  set editingItem to id
        this.setEditingQuestionId(v);
      }
    },
    selected: {
      get() {
        //  returns true if page is selected
        return this.selectedPageId == this.context.id;
      },
      set(v) {
        this.setSelectedPageId(v);
      }
    },
    contextTitle: {
      get() {
        //  return the context title
        return { html: this.context.text };
      },
      set(v) {
        //  update the context title
        this.updateContextText({ text: v });
      }
    }
  },
  watch: {
    selected: function(n, o) {
      //  if we are going from false to true focus
      if (n && !o) {
        this.$refs.contextTitle.focus();
      }
    },
    focusTo: function(n) {
      //  if we are going from false to true focus
      if (n == 'listItemContextTitle') {
        console.log('focus to list item');
        this.$refs.contextTitle.focus();
      }
    }
  },
  methods: {
    ...mapActions('context', ['updateContextText']),
    ...mapMutations('views/context', [
      'setHoveringItem',
      'setEditingQuestionId',
      'setSelectedPageId',
      'setFocusTo'
    ]),
    tabToPage() {
      //  Focus on page content
      this.setFocusTo('page');
    },
    enableEditing() {
      this.editing = this.context.id;
      //  focus the editor
      this.$nextTick(() => {
        this.$refs.editor.focus();
      });
    },
    createNewItem() {
      //const args = { text, order, type };
    }
  }
};
</script>

<style>
.question-list-item {
  position: relative;
  width: 100%;
  transition: 0.1s ease background-color;
  cursor: pointer;
  border-radius: 2px 0 0 2px;
}

.context-title {
  cursor: text;
}
</style>
